import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n';
import { Badge } from '../../../components/Shared/Badge';
import { isBlockedByReview, type BillableRow } from './billableRun';

/**
 * Shown on a billable row whose active offer still has positions without billing kind
 * („zu prüfen", FAFD-27). Links to the offer, where the kind is set; until then the row
 * cannot be selected because the backend would reject the invoice.
 */
export function NeedsReviewBadge({ row }: { row: BillableRow }) {
  const { t } = useTranslation('invoices');
  if (!isBlockedByReview(row)) return null;

  return (
    <Link to={`/offers/${row.offerId}`} title={t('invoices:billable.needsReviewHint')}>
      <Badge variant="danger">
        {t('invoices:billable.needsReview', { count: row.needsReviewCount ?? 0 })}
      </Badge>
    </Link>
  );
}
